export const OWNER = 'owner';
export const EDITOR = 'editor';
export const VIEW_ONLY = 'view-only';
